import { useMemo, useState } from "react";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import { useTranslation } from "react-i18next";
import { SubjectHistory } from "../../../redux/apiSpecifications/apiSubjects";
import { CellWrapper } from "../../../style/CellWrapper";
import { dateToDisplayDate } from "../../../utils/date";
import ModifyDescription from "./ModifyDescription/ModifyDescription";
import { TableWrapper } from "../../../style/TableWrapper";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { MRT_Localization_IT } from "material-react-table/locales/it";
import { MRT_Localization_EN } from "material-react-table/locales/en";

interface IEntityHistoryListProps {
  historical: SubjectHistory[];
}

const EntityHistoryList = ({ historical }: IEntityHistoryListProps) => {
  const { t } = useTranslation();

  const { language } = useSelector((state: RootState) => state.user) || {};

  const items = useMemo(
    () =>
      historical.map((item) => {
        return {
          ...item,
        } as EntityHistoryListItem;
      }) || [],
    [historical]
  );

  const columns = useMemo<MRT_ColumnDef<EntityHistoryListItem>[]>(
    () => [
      {
        accessorKey: "modifyTimestamp",
        header: t("policy-subject-historical-tab-date"),
        size: 100,
        Cell: ({ row }) => (
          <CellWrapper onClick={() => {}}>
            {dateToDisplayDate(row.original.modifyTimestamp)}
          </CellWrapper>
        ),
      },
      {
        accessorKey: "modifyUser",
        header: t("policy-subject-historical-tab-user"),
        size: 100,
        Cell: ({ row }) => (
          <CellWrapper onClick={() => {}}>
            {row.original.modifyUser}
          </CellWrapper>
        ),
      },
      {
        accessorKey: "modifyDescription",
        header: t("policy-subject-historical-tab-description"),
        size: 300,
        enableSorting: false,
        Cell: ({ row }) => (
          <CellWrapper onClick={() => {}}>
            <ModifyDescription item={row.original} />
          </CellWrapper>
        ),
      },
    ],
    [historical, language]
  );

  return (
    <TableWrapper>
      <MaterialReactTable
        columns={columns}
        data={items}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableHiding={false}
        enableFilters={true}
        enableColumnActions={false}
        enableColumnDragging={false}
        enableSorting={true}
        enableTopToolbar={true}
        localization={
          language === "it" ? MRT_Localization_IT : MRT_Localization_EN
        }
      />
    </TableWrapper>
  );
};

export default EntityHistoryList;

export type EntityHistoryListItem = SubjectHistory & {};
